import React from "react";
import MultipleFileInput from "components/FormElements/MultipleFileInput";
import { Container, DesTag } from "styles/components/UploadSpecification";

const UploadSpecification = (props) => {
  return (
    <>
      <Container>
        <MultipleFileInput
          name={props?.name}
          props={props}
          acceptFiles={
            "image/png,image/jpeg,image/gif,image/GIF,application/pdf,application/PDF,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          }
          errorMsg={
            props?.acceptFiles &&
            "File extension must be jpeg, png, gif, pdf, excel,doc and docx"
          }
          placeholder={"Upload Specification"}
          attachOption="multiple"
          fileArr={props?.fileArr}
          response={props?.response}
          btnTxt={props?.btnName}
          mandatory={props?.mandatory}
          callBack={(imageArr) => {
            props?.callBackFun && props?.callBackFun(imageArr);
          }}
        />
      </Container>

      <DesTag className="note">
        <dd>{props.locale("fileUploadLimit")}</dd>
      </DesTag>
    </>
  );
};

export default UploadSpecification;
